import { z } from 'zod';
import { idSchema } from '../common';
import { Privilegio } from './privilegi';

/**
 * Il PRINCIPAL è l'attore autenticato, indipendentemente da come si è
 * autenticato: cookie di sessione (SPA) o API key (servizi).
 * È un contratto di rete (lo restituiscono login e `/me`), quindi vive qui in
 * `shared`: API e web ne condividono il tipo, nessuna duplicazione.
 */
export const principalSchema = z.object({
  id: idSchema,
  /** Nome e cognome dell'utente: per il display (saluto, avatar). Separati come
   *  in anagrafica, così il client compone ciò che gli serve. Vuoti per un
   *  principal di servizio (API key): in quel caso il display ripiega su email. */
  nome: z.string(),
  cognome: z.string(),
  email: z.string(),
  /** NOME del ruolo (dato, non enum) — per display/audit. */
  ruolo: z.string(),
  /** Privilegi EFFETTIVI: `ruolo.privilegi ∪ extra utente` (RBAC). */
  privilegi: z.array(Privilegio),
  /** `true` se l'utente ha un'immagine profilo: la shell mostra l'avatar invece delle iniziali. */
  haImmagine: z.boolean(),
  /** Come è stato autenticato: serve solo a decidere se applicare il CSRF. */
  via: z.enum(['sessione', 'api-key']),
});
export type Principal = z.infer<typeof principalSchema>;

/**
 * Risposta del login: il principal appena autenticato e il token CSRF riemesso
 * (la rigenerazione dell'id di sessione invalida il precedente).
 */
export const loginResponseSchema = z.object({
  principal: principalSchema,
  csrfToken: z.string(),
});
export type LoginResponse = z.infer<typeof loginResponseSchema>;
